<template>
  <div>
    <div class="grid grid-4 gap-2 py-2">
      <div class="bg-gray-100 flex gap-4 px-4 py-2 border-b">
        <VueCtkDateTimePicker
          v-model="created"
          :onlyDate="true"
          :format="'YYYY-MM-DD'"
          :formatted="'ll'"
          :label="'Start Date'"
          locale="en"
          :range="false"
          :inititale-value="dateRange"
          class="w-40"
        >
        </VueCtkDateTimePicker>
        <YInput
          label="Payment Amount"
          v-model="paymentAmount"
          :required="true"
        />
        <YInput
          label="Confirmation Url"
          v-model="transactionUrl"
          :required="true"
          class="flex-grow"
        />
        <div class="flex items-center justify-center w-12">
          <YButton
            @click="createBitcoinPayment"
            color="link"
            class="px-3"
            :is-loading="isUpserting"
            :disabled="isUpserting"
          >
            <Icon v-if="!isUpserting" name="plus" />
            <Icon v-if="isUpserting" name="loading" class="animate-spin" />
          </YButton>
        </div>
      </div>

      <YTable
        class="table-striped table-hover overflow-hidden"
        :scroll-x="false"
        :data="userPaymentHistory?.data || []"
        :isLoading="!userPaymentHistory"
      >
        <template slot="header-row">
          <th style="min-width:9rem; max-width: 9rem;">
            Amount
          </th>
          <th style="width: 5rem">
            Created At
          </th>
          <th>
            Transaction Url
          </th>
          <!-- <th></th> -->
        </template>

        <template slot="row" slot-scope="props">
          <td>${{ props.rowData.targetValue }}</td>
          <td>
            {{ props.rowData.created }}
          </td>
          <td>
            <a
              :href="props.rowData.transactionUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ truncateUrl(props.rowData.transactionUrl) }}
            </a>
          </td>
          <td>
            <a href="#" @click.prevent="deleteBitcoinPayment(props.rowData.id)">
              <Icon name="trashCan" :size="4" class="inline text-red-500"
            /></a>
          </td>
        </template>

        <template v-slot:after>
          <YPagination
            v-if="userPaymentHistory.paginatorInfo"
            :data="userPaymentHistory.paginatorInfo"
            @load-page="loadPage"
            @next-page="nextPage"
            @previous-page="previousPage"
            :key="totalPages"
            @per-page="perPageSelection"
          ></YPagination>
        </template>
      </YTable>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
import USER_PAYMENT_HISTORY from '@/graphql/PaymentOption/UserPaymentHistory.gql'
import YPagination from '@/components/ui/YPagination.vue'
export default {
  mixins: [ValidationErrorsMixin],
  components: {
    YPagination
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  apollo: {
    userPaymentHistory: {
      query: USER_PAYMENT_HISTORY,
      update: data => data.userPaymentHistory,
      variables() {
        return {
          page: this.currentPage,
          first: this.perPage,
          filters: {
            userId: { value: [this.user?.id] },
            paymentType: {
              value: 'bitcoin',
              modifiers: { matchType: 'equals' }
            }
          },
          orderBy: [{ column: 'created', order: 'DESC' }]
        }
      },
      result({ data }) {
        console.log(this.currentPage)
        this.totalPages = data.userPaymentHistory.paginatorInfo.lastPage
      },
      fetchPolicy: 'network-only',
      deep: true
    }
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      paymentAmount: null,
      transactionUrl: null,
      isUpserting: false,
      created: this.$dateTime.local().toFormat('yyyy-LL-dd'),
      dateRange: this.$dateTime.local().toFormat('yyyy-LL-dd')
    }
  },
  mounted() {
    this.$events.listen('refreshPayments', () => {
      this.$apollo.queries.userPaymentHistory.refetch()
    })
  },
  methods: {
    loadPage(page) {
      this.currentPage = page
    },
    nextPage() {
      this.currentPage++
    },
    previousPage() {
      this.currentPage--
    },
    perPageSelection(value) {
      this.perPage = value
    },
    loadMore() {
      this.perPage = this.perPage + this.loadMoreIncrement
    },
    truncateUrl(url) {
      if (!url) return ''
      return url.length > 30 ? url.slice(0, 30) + '...' : url
    },
    clearForm() {
      this.paymentAmount = null
      this.transactionUrl = null
    },
    createBitcoinPayment() {
      this.isUpserting = true

      let input = {
        amount: this.paymentAmount,
        userId: this.user.id,
        transactionUrl: this.transactionUrl,
        paymentType: 'bitcoin',
        created: this.created ? this.created : undefined
      }

      this.$apollo
        .mutate({
          mutation: gql`
            mutation CreateBitcoinPaymentListing($input: BitcoinPaymentInput) {
              createBitcoinPaymentListing(input: $input) {
                status
                errors
                __typename
              }
            }
          `,
          variables: {
            input: input
          }
        })
        .then(() => {
          this.$events.emit('refreshPayments', true)
        })
        .catch(error => {
          console.log(error)
        })
      this.isUpserting = false
    },
    deleteBitcoinPayment(id) {
      this.isUpserting = true
      this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteBitcoinPaymentListing($id: ID!) {
              deleteBitcoinPaymentListing(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: id
          }
        })
        .then(() => {
          this.isUpserting = false
          this.$events.emit('refreshPayments', true)
        })
        .catch(error => {
          console.log(error)
          this.isUpserting = false
        })
    }
  }
}
</script>
